/*** Append CSS in Head ***/
	var css = '.template-collection .rte.collection-description, .template-collection .rte.collection-description{display: block; width: 100%;}.template-collection .rte.collection-description{transition: height 100ms;overflow: hidden;}',
	head = document.head || document.getElementsByTagName('head')[0],
	style = document.createElement('style');
	style.type = 'text/css';
	if (style.styleSheet){
	  style.styleSheet.cssText = css;
	} else {
	  style.appendChild(document.createTextNode(css));
	}
	head.appendChild(style);
	
    jQuery(document).ready(function(jQuery) {	
	/*** Script : Show/Hide Read More ***/
        var i=0; var div_ht = 0;
		jQuery('.collection-description').each(function(){ var height_p = jQuery(this).find('p').height(); 
			if(height_p<10){height_p=10;} if(i==0){ div_ht = height_p + 10; console.log(div_ht)} i++; });
		jQuery( ".template-collection .rte.collection-description" ).after( '<div class="collection-description page-width rm-link-div"><a href="javascript:void(0);" class="rm-link more" id="rm-link-more">...Read more</a><a href="javascript:void(0);" class="rm-link less" id="rm-link-less">...Close</a></div>' );
		jQuery(".template-collection .rte.collection-description").css("max-height","none");
		jQuery(".template-collection .rte.collection-description").css("height",div_ht+"px");	
		jQuery("#rm-link-less").css("display","none");		
		/*** Read More Close ***/		
		jQuery( "#rm-link-less" ).click(function(){
			jQuery("#rm-link-more").css("display","block");
			jQuery("#rm-link-less").css("display","none");
			jQuery(".template-collection .rte.collection-description").css("max-height","none");
			jQuery(".template-collection .rte.collection-description").css("height",div_ht+"px");	//62px
		});
		/*** Read More Full ***/
		jQuery( "#rm-link-more" ).click(function(){
			jQuery("#rm-link-more").css("display","none");
			jQuery("#rm-link-less").css("display","block");
			jQuery(".template-collection .rte.collection-description").css("max-height","none");
			jQuery(".template-collection .rte.collection-description").css("height","auto");	
		});
		
		/*** Script : Size Page ***/
		
	});	

/**** Embroidery - Logo Upload ****/

jQuery("#fileToUpload").change(function(){
          readLogoURL(this,"logo-img");
        });
		
		function readLogoURL(input,image_field_val) {
          if (input.files && input.files[0]) {
              var reader = new FileReader();
				reader.onload = function (e) {
                jQuery('#img-show').html("<img src='"+e.target.result+"' width='100' style='padding-bottom:10px;'><br><span id='uploading' style='margin-left:180px'><strong>Uploading...</strong></span>");
                jQuery('#img-show').css("opacity",0.4);
                var img = e.target.result;
                
                jQuery.post("https://magewares.com/shopify/upload.php?action=get",
                {
                  img: img,
                },
                function(data,status){
                    if (status == "success") 
                    {
                       jQuery("#"+image_field_val).val(data);	
                       jQuery('#uploading').css("display","none");
                       jQuery('#img-show').css("opacity",1);
                    }
                });
              }

              reader.readAsDataURL(input.files[0]);              
          }
      	}

		/*** Form Post ***/

        function logoformpost(){
          
			var name = jQuery("#name").val();
            var email = jQuery("#email").val();
          	var img = jQuery("#logo-img").val();
            var style = jQuery("#style").val();
            var phone = jQuery("#phone").val();
            var qty = jQuery("#qty").val();
            var comment = jQuery("#comment").val();
          	
            if(img=="" || email=="" || name=="" || style=="" || qty=="" || comment==""){
             jQuery("#logo-error").html("Please fill all mandatory fields!");
           		return; 
            }
          else{
            jQuery("#logo-error").html("");
            jQuery.post("https://magewares.com/shopify/logo_submit_uis.php?action=get",
            {
                  logo: img,
              	  name: name,
              	  email: email,
              	  style: style,
              	  phone: phone,
              	  qty: qty,
                  comment: comment,
                },
                function(data,status){
                    if (status == "success") 
                    {
                       jQuery('#contactForm').css("display","none");
                       jQuery('#logo-success').css("display","block");
                    }
                });
          }
        }


jQuery(document).ready(function(){
		jQuery('.expand-collaspe a').click(function(e){
				e.preventDefault();
				var parent = jQuery(this).parent().parent();
				if (parent.hasClass('collasped')) {
					parent.removeClass('collasped').addClass('expanded');
				} else {
					parent.removeClass('expanded').addClass('collasped');
				}
		});
	});

jQuery(document).ready(function(){
  //for shop listing page
    setTimeout(function () {
       jQuery( ".bc-sf-filter-option-multiple-list li" ).each(function( index ) {
         let val = jQuery( this ).find('input').attr('data-title');
         jQuery( this ).find('input').attr("aria-labelledby","bc-sf-filter-option-value-"+val);
         jQuery( this ).find('input').next().attr("id","bc-sf-filter-option-value-"+val);
        });
        //for brand details page contrast error
        jQuery('div.product-single__description p:nth-child(3) span:nth-child(1)').css("color", "#3A6573");
        jQuery('div.shg-theme-text-content p:nth-child(1)').css('color','#000000');
        
   }, 2000);
  jQuery("#bc-sf-filter-collection-header").css("color", "#3A6573");
  jQuery(".shogun-heading-component h1").css("color", "#3A6573");
  // jQuery('.shg-btn .shg-cse').hover(function(){
  //           jQuery(this).css('color', '#3A6573');
  //  }
  jQuery('div.shg-row').find('a').css("font-size", "24px");                                 
  jQuery('div.s4com-section-title').css('color', '#3A6573'); 
});